import { render, staticRenderFns } from "./listagemSolicitacoes.vue?vue&type=template&id=d68cad44&scoped=true&lang=pug&"
import script from "./listagemSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./listagemSolicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./listagemSolicitacoes.vue?vue&type=style&index=0&id=d68cad44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68cad44",
  null
  
)

export default component.exports